import { publicClient } from '../../client';
import {
  LoginEmailAndPasswordMutationVariables,
  Session,
  LoginEmailAndPasswordMutation,
  LoginEmailAndPasswordDocument,
  RefreshTokenDocument,
  RefreshTokenMutation,
  RefreshTokenMutationVariables,
} from '../types';

// [Public] Login a user with email and password
export async function loginEmailAndPassword(variables: LoginEmailAndPasswordMutationVariables): Promise<Readonly<Session>> {
  try {
    const result = await publicClient.mutate<LoginEmailAndPasswordMutation, LoginEmailAndPasswordMutationVariables>({
      mutation: LoginEmailAndPasswordDocument,
      variables,
    });
    return result.data.login_email_password;
  } catch (error) {
    throw Error(error);
  }
}

// [Public] Refresh a token with refresh_token
export async function refreshToken(variables: RefreshTokenMutationVariables): Promise<Readonly<Session>> {
  try {
    const result = await publicClient.mutate<RefreshTokenMutation, RefreshTokenMutationVariables>({
      mutation: RefreshTokenDocument,
      variables,
    });
    return result.data.refresh_token;
  } catch (error) {
    throw Error(error);
  }
}
